import UserType from 'constants/user';
import { useAuth } from 'contexts/AuthContext';
import { useUrlQuery } from 'hooks/useUrlQuery';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import { RootState } from 'redux/store';
import { PATH } from './constant';
import { UserQuizStatus } from 'containers/quiz_manager';

export default function PrivateRouteCustomer({ component: Component, ...rest }) {
    // const accessToken = getTokenAccess();
    const { currentUser } = useAuth();
    const user = useSelector((state: RootState) => state.userDetail.me);
    const query = useUrlQuery();
    const storeId = query.get('storeId');
    useEffect(() => {
        if (storeId) {
            sessionStorage.setItem('storeId', storeId);
        }
    }, [storeId]);

    const pendingQuizzes = useSelector((state: RootState) => state.userDetail.pendingQuizzes);
    const isPendingQuizzes =
        pendingQuizzes?.hasOwnProperty('getPendingQuizzes') &&
        pendingQuizzes?.getPendingQuizzes?.quizConfigs?.filter((item) => item.status === UserQuizStatus.pending)
            ?.length;
    return (
        <Route
            {...rest}
            render={(props) => {
                let { location } = props;

                return currentUser ? (
                    user && user.userType === UserType.Customer ? (
                        isPendingQuizzes === 0 || location.pathname === PATH.QUIZ_MANAGER ? (
                            <Component {...props} />
                        ) : (
                            <Redirect
                                to={{
                                    pathname: PATH.QUIZ_MANAGER,
                                    state: { from: location },
                                }}
                            />
                        )
                    ) : (
                        <Redirect
                            to={{
                                pathname: '/home',
                                state: { from: location },
                            }}
                        />
                    )
                ) : (
                    <Redirect
                        to={{
                            pathname: '/login',
                            state: { from: location },
                        }}
                    />
                );
            }}
        />
    );
}
